import { useQuery } from 'react-query';
import axios from 'axios';

import { apiConfig, GRID_INVENTORY_REFETCH_INTERVAL } from '@constants';

// Binary Data Utilities

const toDataViewObject = arrayBuffer => {
  const view = new DataView(arrayBuffer);
  const bytesPerValue = 4;

  return {
    bigEndianView: view,
    length: view.byteLength / bytesPerValue,
    valueAt: index => {
      const scaledIndex = index * bytesPerValue;

      if (scaledIndex < 0 || scaledIndex > view.byteLength - bytesPerValue) {
        return null;
      }

      // getFloat32 converts from the big endian data to little endian.
      return view.getFloat32(scaledIndex, false);
    },
  };
};

// Inventory

const getGriddedProductInventoryURL = (productNumber, variableID) =>
  `${apiConfig.TWC_API_BASE_V2}${apiConfig.TWC_API_MAP_GRIDDED_INVENTORY}?products=${productNumber}:${variableID}&apiKey=${apiConfig.TWC_API_KEY}`;

const getGriddedProductInventory = async (productNumber, variableID) =>
  await axios.get(getGriddedProductInventoryURL(productNumber, variableID));

export const useGetGriddedProductInventory = (productNumber, variableID) =>
  useQuery(
    `getGriddedProductInventory-${productNumber}-${variableID}`,
    () => getGriddedProductInventory(productNumber, variableID),
    {
      refetchInterval: GRID_INVENTORY_REFETCH_INTERVAL,
    },
  );

// Tile

const getGriddedProductTileURL = (
  productNumber,
  variableID,
  rt,
  t,
  x,
  y,
  z,
  TWC_API_BASE_V2,
  TWC_API_MAP_GRIDDED_TILE,
  TWC_API_KEY,
) =>
  `${apiConfig.TWC_API_BASE_V2}${apiConfig.TWC_API_MAP_GRIDDED_TILE}?products=${productNumber}:${variableID}&rt=${rt}&t=${t}&lod=${z}&x=${x}&y=${y}&apiKey=${apiConfig.TWC_API_KEY}`;

const getGriddedProductTile = async (productNumber, variableID, rt, t, x, y, z) => {
  const { data } = await axios.get(getGriddedProductTileURL(productNumber, variableID, rt, t, x, y, z), {
    responseType: 'arraybuffer',
  });

  return toDataViewObject(data);
};

export const useGetGriddedProductTile = (productNumber, variableID, rt, t, x, y, z) =>
  useQuery(
    `getGriddedProductTile-${productNumber}-${variableID}-${rt}-${t}-${x}-${y}-${z}`,
    () => getGriddedProductTile(productNumber, variableID, rt, t, x, y, z),
    {
      refetchInterval: GRID_INVENTORY_REFETCH_INTERVAL,
    },
  );
